<template>
  <div class="insight-news-page-container">
    <!-- news headlines -->
    <NewsHeadlineCarousel></NewsHeadlineCarousel>

    <!-- Featured News -->
    <FeaturedNews></FeaturedNews>

    <!--UniBit Opinions -->
    <!-- <UnibitOpinions></UnibitOpinions> -->
  </div>
</template>



<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import NewsHeadlineCarousel from "@/components/insight-page-components/news-headline-carousel";
import FeaturedNews from "@/components/insight-page-components/featured-news";
// import UnibitOpinions from "@/components/insight-page-components/unibit-opinions";

export default {
  components: {
    PulseLoader,
    NewsHeadlineCarousel,
    FeaturedNews
    // UnibitOpinions
  },

  data() {
    return {
      curPage: 0
    };
  },

  mounted() {
    // Step 4: handle scroll top event
    this.scroll();
  },

  methods: {
    scroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight ===
          document.documentElement.offsetHeight;
        console.log(
          "[insight-news-page] scroll() route name is: ",
          this.$route.name
        );
        if (bottomOfWindow && this.$route.name == "news-page") {
          if (this.curPage > 0) this.showMoreNews();
          console.log("reach bottom");
        }
      };
    }
  }
};
</script>


<style scoped>
h2 {
  font-family: Raleway;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.53px;
  color: #4a4a4a;
}

.pic {
  text-align: center;
}

.pic > img {
  width: 81px;
  height: 60px;
}

.title {
  margin: 1.5rem auto;
  align-items: center;
  justify-content: space-between;
}

.title span {
  color: #f5a623;
  font-size: 16px;
  letter-spacing: 0.35px;
}

.title > div > span:first-child {
  text-decoration: underline;
}

.title span:hover {
  cursor: pointer;
}

.title .icon-chevron-right {
  width: 21px;
  height: 24px;
  margin-bottom: 2px;
}

.opinion-news {
  padding-bottom: 0.5rem;
  /* border-bottom: dashed 1px #979797; */
  align-items: center;
}

.opinion-news > div.col-9 {
  margin-top: 0.5rem;
}

.opinion-news > div > #NewsSource {
  opacity: 0.34;
  font-family: Raleway;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.24px;
  color: #4a4a4a;
}

.opinion-news > div > #NewsTitle {
  margin-top: 2px;
  font-family: Raleway;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.24px;
}

.opinion-news > div > #NewsTitle > a {
  color: #4a4a4a;
}

.opinion-news > div > #NewsContent {
  margin-top: 4px;
  font-family: Raleway;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.23px;
  color: #4a4a4a;
}

.opinion-news > div > #NewsDateTime {
  margin-top: 0.25rem;
  opacity: 0.38;
  font-family: Avenir;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.23px;
  color: #4a4a4a;
}

.featured-section > h2 {
  font-family: Raleway;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.53px;
  color: #4a4a4a;
  margin-top: 20px;
  margin-bottom: 16px;
}

.news-detail {
  align-items: center;
  margin-bottom: 1rem;
}

.news-detail p {
  font-size: 10px;
  font-family: Avenir;
}

.news-detail > div.col-3 {
  padding-left: 5px;
  padding-right: 0px;
}

.news-detail > div > #NewsSource > span {
  opacity: 0.34;
  font-family: Raleway;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.24px;
  color: #4a4a4a;
}

.news-detail > div > #NewsTitle {
  margin-top: 0.5rem;
  font-family: Raleway;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.24px;
  color: #4a4a4a;
}

.news-detail > div > #NewsTitle > span {
  color: #5088e3;
}

.news-detail > div > #NewsTitle > span:hover {
  cursor: pointer;
}

.news-detail > div > #NewsContent {
  margin-top: 0.25rem;
  font-family: Raleway;
  font-size: 10px;
  letter-spacing: 0.24px;
  color: #4a4a4a;
}

.news-detail > div > #NewsDateTime {
  margin-top: 0.25rem;
  opacity: 0.38;
  font-family: Avenir;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.41px;
  color: #4a4a4a;
}

.icon-lock {
  width: 16px;
  height: 15px;
  color: #f5a623;
  margin-bottom: 5px;
}

.icon-lock:hover {
  cursor: pointer;
}

/* css for desktop */
@media (min-width: 768px) {
  .icon-search {
    height: 16px;
    width: 16px;
    stroke: #5a5c5c;
    opacity: 0.49;
  }

  h2 {
    font-family: Avenir;
    font-size: 32px;
    font-weight: 500;
    letter-spacing: 0.94px;
    color: #4a4a4a;
  }

  #NewsSource {
    font-family: Raleway;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.47px;
    color: #4a4a4a;
  }

  #NewsTitle {
    font-family: Raleway;
    font-size: 24px;
    margin-top: 1rem;
    font-weight: 600;
    letter-spacing: 0.71px;
    color: #4a4a4a;
  }

  #NewsContent {
    font-family: Raleway;
    margin-top: 1rem;
    font-size: 18px;
    letter-spacing: 0.59px;
    color: #4a4a4a;
  }

  #NewsDateTime {
    font-family: Avenir;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.41px;
    color: #4a4a4a;
  }

  .pic {
    text-align: center;
  }

  .pic > img {
    height: 120px;
  }

  .title {
    margin: 2rem auto;
    align-items: center;
    justify-content: space-between;
  }

  .title span {
    color: #f5a623;
    font-size: 24px;
    letter-spacing: 0.71px;
  }

  .title > div > span:first-child {
    text-decoration: underline;
  }

  .title span:hover {
    cursor: pointer;
  }

  .title .icon {
    width: 24px;
    height: 28px;
  }

  .opinion-news {
    padding-bottom: 1rem;
    border-bottom: dashed 1px #979797;
    align-items: center;
  }

  .opinion-news > div.col-9 {
    margin-top: 1.5rem;
  }

  .opinion-news > div > #NewsSource {
    opacity: 0.34;
    font-family: Raleway;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.47px;
    color: #4a4a4a;
  }

  .opinion-news > div > #NewsTitle {
    margin-top: 0.5rem;
    font-family: Raleway;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0.53px;
  }

  .opinion-news > div > #NewsTitle > a {
    color: #4a4a4a;
  }

  .opinion-news > div > #NewsContent {
    margin-top: 0.5rem;
    font-family: Avenir;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.41px;
    color: #4a4a4a;
  }

  .opinion-news > div > #NewsDateTime {
    margin-top: 0.5rem;
    opacity: 0.38;
    font-family: Avenir;
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.41px;
    color: #4a4a4a;
  }

  .featured-section > h2 {
    font-size: 32px;
    font-weight: 500;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .news-detail {
    align-items: center;
    margin-bottom: 1.5rem;
  }

  .news-detail p {
    font-size: 14px;
    font-family: Avenir;
  }

  .news-detail > div.col-3 {
    padding-left: 15px;
    padding-right: 15px;
  }

  .news-detail > div > #NewsSource > span {
    opacity: 0.34;
    font-family: Raleway;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.47px;
    color: #4a4a4a;
  }

  .news-detail > div > #NewsTitle {
    margin-top: 0.5rem;
    font-family: Raleway;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0.53px;
    color: #4a4a4a;
  }

  .news-detail > div > #NewsContent {
    margin-top: 0.5rem;
    font-family: Avenir;
    font-size: 14px;
    letter-spacing: 0.41px;
    color: #4a4a4a;
  }

  .news-detail > div > #NewsDateTime {
    margin-top: 0.5rem;
    opacity: 0.38;
    font-family: Avenir;
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.41px;
    color: #4a4a4a;
  }

  .icon-lock {
    width: 20px;
    height: 25px;
    color: #f5a623;
    margin-bottom: 5px;
    margin-left: 3px;
  }

  .icon-lock:hover {
    cursor: pointer;
  }

  .footer-link {
    margin-top: 1.5rem;
    font-family: Avenir;
    font-size: 24px;
    font-weight: 300;
    color: #f5a623;
    letter-spacing: 0.71px;
  }

  .footer-link > p > span:first-child {
    text-decoration: underline;
  }

  .footer-link .icon {
    width: 24px;
    height: 28px;
    margin-left: -2px;
    margin-bottom: 2px;
  }

  .footer-link:hover {
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/insight-pages/insight-news-page.vue